export default class SurveysSectionsEdit {

  constructor() {}

  render() {

    // Display previous on select
    $('#answerRequired').change(function() {
      if ($(this).is(':checked')) {
        $('.previous-answer-input').removeClass('d-none');
      } else {
        $('.previous-answer-input').addClass('d-none');        
      }
    })

  }
}
